import { render, staticRenderFns } from "./navIcon.vue?vue&type=template&id=6f3a27d4&scoped=true"
import script from "./navIcon.vue?vue&type=script&lang=js"
export * from "./navIcon.vue?vue&type=script&lang=js"
import style0 from "./navIcon.vue?vue&type=style&index=0&id=6f3a27d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f3a27d4",
  null
  
)

export default component.exports